<div kalDialogContent
     [formGroup]="form"
     [kalLoading]="loading">
    <kal-form-field>
        <kal-input label="Nom du pays"
                   formControlName="countryName">
        </kal-input>
    </kal-form-field>

    <kal-form-field>
        <kal-input label="Code du pays"
                   formControlName="countryCode">
        </kal-input>
    </kal-form-field>
</div>

<div kalDialogFooter>

    <div class="gup-C-validationArea gup-O-list">

        <div class="gup-O-list__item">

            <kal-button (click)="submit()"
                        [disabled]="form.invalid"
                        kalTheme="primary">
                Ajouter
            </kal-button>

        </div>

        <div class="gup-O-list__item">

            <kal-button (click)="cancel()"
                        kalTheme="secondary">
                Annuler
            </kal-button>

        </div>

    </div>

</div>
